import { TRADINGACCOUNTSTOTRANSFER__MUTATIONS } from "../mutation-types";
import { TRADINGACCOUNTSTOTRANSFER__ACTIONS } from "../action-types";
import { TRADINGACCOUNTSTOTRANSFER__API } from "@/_helpers/urls";
import http from "@/_helpers/http";
import toast from "@/services/Notification";
import router from "@/router";

// State
const state = {
  tradingAccounts: [],
  user_ib_balance: 0,
  step: 1,
  errorMessage: null,
  all_ib: [],
  all_crypto: [],
  all_bank: [],
};

// Mutations
const mutations = {
  [TRADINGACCOUNTSTOTRANSFER__MUTATIONS.TRADINGACCOUNTSTOTRANSFER](
    state,
    data
  ) {
    state.tradingAccounts = data.tradingAccounts;
    state.user_ib_balance = data.user_ib_balance;
  },

  SET_STEP(state, step) {
    state.step = step;
  },

  SET_ERRORMESSAGE(state, data) {
    state.errorMessage = data;
  },
  //crypto
  [TRADINGACCOUNTSTOTRANSFER__MUTATIONS.ALLCRYPTOADDRESS](
    state,
    data
  ) {
    state.all_crypto = data;
  },
   //get all bank
  [TRADINGACCOUNTSTOTRANSFER__MUTATIONS.ALLBANKADDRESS](
    state,
    data
  ) {
    state.all_bank = data;
  },
  
};

const getters = {};

// Actions
const actions = {

  //get bank
  async [TRADINGACCOUNTSTOTRANSFER__ACTIONS.ALLBANKADDRESS]({ commit }) {
    try {
      const data = await http().get(TRADINGACCOUNTSTOTRANSFER__API.ALLBANKADDRESS);
          commit(
      TRADINGACCOUNTSTOTRANSFER__MUTATIONS.ALLBANKADDRESS,
      data?.data?.bankAddress || []
    );
    } catch (error) {
      console.error("Error fetching:", error);
    }
  },
  //crypto transfer
  async [TRADINGACCOUNTSTOTRANSFER__ACTIONS.ALLCRYPTOADDRESS]({ commit }) {
    try {
      const data = await http().get(TRADINGACCOUNTSTOTRANSFER__API.ALLCRYPTOADDRESS);
      commit(TRADINGACCOUNTSTOTRANSFER__MUTATIONS.ALLCRYPTOADDRESS, data?.data?.formatedData);
    } catch (error) {
      console.error("Error fetching:", error);
    }
  },
  async [TRADINGACCOUNTSTOTRANSFER__ACTIONS.TRANSFERTOCRYPTOSENDOTP](
    { commit },
    value
  ) {
    try {
      const response = await http().post(
        TRADINGACCOUNTSTOTRANSFER__API.TRANSFERTOCRYPTOSENDOTP,
        {
          cryptoId: value?.cryptoId,
          amount: Number(value?.amount),
        }
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        return { success: true };
      }
    } catch (error) {
      console.error("Error fetching:", error);
      toast.error(error.response.data.message || "Otp not sent");
    }
  },

  async [TRADINGACCOUNTSTOTRANSFER__ACTIONS.CONFIRMTRANSFERTOCRYPTO](
    { dispatch },
    value
  ) {
    try {
      const response = await http().post(
        TRADINGACCOUNTSTOTRANSFER__API.CONFIRMTRANSFERTOCRYPTO,
        {
          verification_code: Number(value?.verification_code),
        }
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        return { success: true };
      }
    } catch (error) {
      console.error("Error fetching:", error);
      toast.error(error.response.data.message);
    }
  },
  //end crypto transfer

  
  async [TRADINGACCOUNTSTOTRANSFER__ACTIONS.TRADINGACCOUNTSTOTRANSFER]({
    commit,
  }) {
    try {
      const { data } = await http().get(
        TRADINGACCOUNTSTOTRANSFER__API.TRADINGACCOUNTSTOTRANSFER
      );
      commit(
        TRADINGACCOUNTSTOTRANSFER__MUTATIONS.TRADINGACCOUNTSTOTRANSFER,
        data?.data
      );
    } catch (error) {
      console.error("Error fetching:", error);
    }
  },

  async [TRADINGACCOUNTSTOTRANSFER__ACTIONS.INTERNALTRANSFERSENDOTP](
    { commit },
    value
  ) {
    try {
      const response = await http().post(
        TRADINGACCOUNTSTOTRANSFER__API.INTERNALTRANSFERSENDOTP,
        {
          client_trading_account_id: value?.client_trading_account_id,
          amount: Number(value?.amount),
        }
      );
      if (response.status === 200) {
        toast.success(response.data.message)
        return { success: true }
      }
    } catch (error) {
      console.error("Error fetching:", error);
      toast.error(error.response.data.message || "Otp not sent")
    }
  },

  async [TRADINGACCOUNTSTOTRANSFER__ACTIONS.CONFIRMINTERNALTRANSFER](
    { commit },
    value
  ) {
    try {
      const response = await http().post(
        TRADINGACCOUNTSTOTRANSFER__API.CONFIRMINTERNALTRANSFER,
        {
          verification_code: Number(value?.verification_code),
        }
      );
      if (response.status === 200) {
        toast.success(response.data.message)
        return { success: true }
      }
      
    } catch (error) {
      console.error("Error fetching:", error);
      toast.error(error.response.data.message);
    }
  },

  async [TRADINGACCOUNTSTOTRANSFER__ACTIONS.BANKTRANSFERSENDOTP](
    { commit },
    value
  ) {
    try {
      const { data } = await http().post(
        TRADINGACCOUNTSTOTRANSFER__API.BANKTRANSFERSENDOTP,
        {
          amount: Number(value.amount),
          bank_name: value.bank_name,
          bank_country: value.bank_country,
          bank_account_name: value.bank_account_name,
          bank_iban: value.bank_iban,
          bank_swift: value.bank_swift,
          bank_address: value.bank_address,
        }
      );
      toast.success(data.message);
      commit("SET_ERRORMESSAGE", null);
      commit("SET_STEP", 3);
    } catch (error) {
      console.error("Error:", error.response.data.message);
      toast.error(error.response.data.message);
      commit("SET_STEP", 1);
    }
  },

  async [TRADINGACCOUNTSTOTRANSFER__ACTIONS.CONFIRMBANKTRANSFER](
    { commit },
    value
  ) {
    try {
      const response = await http().post(
        TRADINGACCOUNTSTOTRANSFER__API.CONFIRMBANKTRANSFER,
        {
          verification_code: Number(value?.verification_code),
        }
      );
      toast.success(response.data.message);
      commit("SET_STEP", 1);
    } catch (error) {
      console.error("Error:", error);
      toast.error(error.response.data.message);
    }
  },
};

export default {
  strict: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
